var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirculo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.441,
    x2: 1,
    y2: 0.448,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5061ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d72ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.133)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 39,
    cy: 39,
    r: 39,
    transform: "translate(0.133)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(8.133 8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirculo);
export default __webpack_public_path__ + "static/media/circulo.fe8b99cfcd0e81e63ba32a616d11c775.svg";
export { ForwardRef as ReactComponent };